export const validations = {
  required: (message?: string) => ({
    required: {
      value: true,
      message: message ?? 'This value is required.'
    }
  }),
  notWhiteSpace: (message?: string) => ({
    required: {
      value: true,
      message: message ?? 'This value is required.'
    },
    validate: (value: string) => {
      if (!value.trim()) {
        return message ?? 'This value is required.';
      }
      return true;
    }
  }),
  pattern: (pattern: RegExp, message?: string) => ({
    pattern: {
      value: pattern,
      message: message ?? 'The value does not match with the expected pattern.'
    }
  })
};
